import { useTheme } from 'styled-components';
import { useMediaQuery } from 'styled-breakpoints/use-media-query';
import { GatsbyImage } from 'gatsby-plugin-image';
import { useMemo } from 'react';
import { CardLink } from 'components/Links';
import { Breadcrumbs } from 'components/Breadcrumbs';
import { Box } from 'components/Box';

import { Container, Section, SectionImage } from 'components/Container';
import { Subtitle } from './styled/Subtitle.styled';

import { TextContainer } from './styled/TextContainer.styled';
import { PreviewCard } from './PreviewCard';

import type { FC } from 'react';
import type { PreviewCardProps } from './types';

/** A card component that previews and links to either a post from either our blog or partner page */
export const HeroPreviewCard: FC<PreviewCardProps> = ({
  categories,
  title,
  subtitle,
  urlSlug,
  description,
  image,
}) => {
  const { breakpoints } = useTheme();

  const isTablet = useMediaQuery(breakpoints.down('xl'));

  const renderedImage = useMemo(
    () => (
      <Box>
        <GatsbyImage
          image={image.gatsbyImageData!}
          alt={image.title || title}
          objectFit="contain"
        />
      </Box>
    ),
    [image.gatsbyImageData, image.title, title]
  );

  if (isTablet) {
    return (
      <PreviewCard
        categories={categories}
        title={title}
        subtitle={subtitle}
        urlSlug={urlSlug}
        description={description}
        image={image}
      />
    );
  }

  return (
    <CardLink to={urlSlug}>
      <Container padding={0}>
        <Section>
          <TextContainer>
            {categories && <Breadcrumbs crumbs={categories} />}
            <Box marginTop={8}>
              <h2>{title}</h2>
            </Box>
            {subtitle && <Subtitle>{subtitle}</Subtitle>}
            {description && (
              <Box marginTop={8}>
                <p>{description}</p>
              </Box>
            )}
          </TextContainer>
        </Section>
        <SectionImage padding={3} image={renderedImage} boxShadow={false} borderRadius={false} />
      </Container>
    </CardLink>
  );
};
